import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../../../layout/default';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserGeneralInfoService } from '../../../services/user';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import UserModal from '../../../components/company/user-modal';
import { getFacilitiesByCompany } from '../../../services/facility';
import DeactivateModal from '../../../components/company/deactivate-modal';
import { usePermission } from '../../../container/permissionContext';
import { redirectToLibrary } from '../../../utility';
import CopyModal from '../../../components/company/copy-modal';
import { utcToLocalDateFormatter } from '../../../utility/dates/utcToLocalDate';
import ActivateModal from '../../user/components/ActivateModal';
import { STATIC_ROUTES } from '../../../constants/routes';
import { isResponseOk } from '../../../utility/isResponseOk';

const GeneralUsersDetailPage = () => {
  const { id } = useParams();
  const [user, setUser] = useState({});
  const [moreIsOpen, setMoreIsOpen] = useState(false);
  const pageBreadcrumbs = [
    {
      url: STATIC_ROUTES.GENERAL_USERS,
      name: 'Users List',
    },
    {
      name: 'User Profile',
    },
  ];

  const getUserGeneralInfo = useCallback(async () => {
    try {
      const response = await getUserGeneralInfoService(id);
      if (isResponseOk(response) && response.data) {
        setUser(response.data);
      }
    } catch (e) {
      console.log(e);
    }
  }, [id]);

  useEffect(() => {
    getUserGeneralInfo();
  }, [getUserGeneralInfo]);

  return (
    <Layout breadcrumbs={pageBreadcrumbs} title={'User Profile'}>
      <div className={`page-wrapper ${user.deleted_at ? 'page-wrapper-deactivated' : ''}`}>
        <div className="company-profile">
          {user.first_name && (
            <>
              <div className="company-profile-header">
                <div className="user-profile-header">
                  <div>
                    <span className="date-add">
                      Date Added: {utcToLocalDateFormatter(user.created_at)}{' '}
                      {user.deleted_at && (
                        <span className="date-add-deactivated">Deactivated: {utcToLocalDateFormatter(user.deleted_at)}</span>
                      )}
                    </span>
                    <h2 className="company-profile-title">
                      {user.last_name} {user.first_name}
                    </h2>
                    <h3 className="company-profile-subtitle">{user.role}</h3>
                  </div>
                </div>
              </div>
              <div className="company-profile-tab user-profile-tab">
                <h3 className="company-profile-title">
                  <img src="/images/company-add-icon-3.svg" className="mr-2" alt="" />
                  Personal Information
                </h3>
                <div className="user-profile-tab-content">
                  <div className="user-profile-tab-item">
                    <h4 className="title">Facility Name:</h4>
                    <p>
                      <strong>{user.facility?.name ? user.facility?.name : '----'}</strong>
                    </p>

                    <h4 className="title">Position:</h4>
                    <p>
                      <strong>{user.position?.name ? user.position?.name : '----'}</strong>
                    </p>
                  </div>
                  <div className="user-profile-tab-item user-profile-tab-user-group">
                    <div>
                      <h4 className="title">Users Group:</h4>
                      {user.user_groups.length ? (
                        user.user_groups.map(
                          (item, index) =>
                            index < 3 && (
                              <p key={item.id}>
                                <strong>{item.name}</strong>
                              </p>
                            ),
                        )
                      ) : (
                        <strong>----</strong>
                      )}

                      {user.user_groups.length > 3 && (
                        <>
                          {moreIsOpen && (
                            <div className="more-group">
                              {user.user_groups.map(
                                (item, index) =>
                                  index >= 3 && (
                                    <p key={item.id}>
                                      <strong>{item.name}</strong>
                                    </p>
                                  ),
                              )}
                            </div>
                          )}
                          <span className="show-more cursor-pointer" onClick={() => setMoreIsOpen(!moreIsOpen)}>
                            {!moreIsOpen ? `${user.user_groups.length - 3} more...` : 'Show Less'}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="user-profile-tab-item ">
                    <h4 className="title">Email:</h4>
                    <p>
                      <strong>{user?.email?.length ? user.email : '-'}</strong>
                    </p>

                    <h4 className="title">Phone Number:</h4>
                    <p>
                      <strong>{user.deleted_at ? '' : user.phone}</strong>
                    </p>
                  </div>
                </div>

                <h3 className="company-profile-title">
                  <img src="/images/settings-icon.svg" className="mr-2" alt="" />
                  System Information
                </h3>
                <div className="user-profile-tab-content">
                  <div className="user-profile-tab-item">
                    {user.creator && (
                      <>
                        <h4 className="title">Added by:</h4>
                        <p>
                          <strong>
                            {user.creator.last_name} {user.creator.first_name}
                          </strong>
                        </p>
                      </>
                    )}
                    <h4 className="title">Date Added:</h4>
                    <p>
                      <strong>{utcToLocalDateFormatter(user.created_at)}</strong>
                    </p>
                  </div>

                  <div className="user-profile-tab-item">
                    <p>
                      <strong>{user?.preferred_notification_type}</strong>
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default GeneralUsersDetailPage;
